import './list-logos.scss';
